import React, { Component } from "react";
import indexImg from "../../../assests/images/Index1.png";
import index2Img from "../../../assests/images/Index2.png";
import index3Img from "../../../assests/images/Index3.png";
//import { Carousel } from "react-bootstrap";
import Aux from "../../../hoc/Aux";
import styled from "styled-components";

// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Carousel } from "react-responsive-carousel";

import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";

import "./Index.css";
import { Link } from "react-router-dom";
import { device } from "../../../theme/device";

const content = [
  {
    linkTo: "vision",
    title: "Coming Soon",
    image: indexImg,
    textLineOne: "YOU DESIGN THE CLOTHES",
    textLineTwo: "YOU BRAND THE STYLE",
    textLineThree: "YOU EARN THE MONEY"
  },
  {
    linkTo: "concept",
    title: "PLATFORM FOR UNIQUE PEOPLE",
    image: index2Img,
    textLineOne: "WE BUILD THE PLATFORM FOR CUSTOMIZABLE CLOTHES",
    textLineTwo: "ENABLING THE LATEST FASHION ON THE SPOT",
    textLineThree: "WITH THE HIGHEST STANDARDS & NO STYLE LIMITATIONS"
  },
  {
    linkTo: "concept",
    title: "EMPOWERING THE CUSTOMER",
    image: index3Img,
    textLineOne: "WEARING WHAT THOUSANDS OF OTHER DO?",
    textLineTwo: "NEVER FINDING THE PERFECT FIT?",
    textLineThree: "IT‘S OVER - DEFINE YOUR OWN STYLE."
  }
];

const StyledLink = styled(Link)`
  &&& {
    text-decoration: none;
    height: 100%;
    //margin-top: 40px;
  }
`;

const Title = styled.div`
  text-transform: uppercase;
  padding-top: 2rem;
  color: ${props => props.theme.colorPrimary};
  font-size: 36pt;
  font-weight: bold;
  padding-left: 17.5rem;

  @media (max-width: 1100px) {
    font-size: 37px;
  }

  @media (max-width: 900px) {
    font-size: 28px;
  }

  @media (max-width: 700px) {
    font-size: 19pt;
    padding-left: 2rem;
  }

  @media (max-width: 400px) {
    font-size: 13pt;
    margin-bottom: 1rem;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  position: relative;
  height: auto;
`;

const BaseImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media (max-width: 700px) {
    height: 60vh;
    object-fit: cover;
    object-position: 50% 100%;
  }

  @media (max-width: 325px) {
    width: 105%;
  }
`;

const TextBlock = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 167px;
  background-color: black;
  opacity: 0.6;
  color: white;
  padding: 15px;

  @media (max-width: 700px) {
    bottom: 0px;
    right: 0px;
    left: 2rem;
  }

  @media (max-width: 325px) {
    bottom: 7px;
    right: -15px;
    left: 2rem;
    padding-top: 5px;
    padding-bottom: 5px;
  }
`;

const TextLine = styled.p`
  margin-bottom: 0px;
  font-weight: 300;
  font-size: 20pt;

  // @media ${device.phone} {
  //   font-size: 0.9rem;
  // }
  //
  // @media ${device.tabletPortrait} {
  //   font-size: 1.7rem;
  // }

  @media (max-width: 1300px) {
    font-size: 17pt;
  }
  
  @media (max-width: 1200px) {
    font-size: 15pt;
  }
  
  @media (max-width: 900px) {
    font-size: 11pt;
  }
  
  @media (max-width: 750px) {
    font-size: 10pt;
  }
  
  @media (max-width: 550px) {
    font-size: 10pt;
    font-weight: 600;
  }
  
`;

class IndexNew extends Component {
  render() {
    return (
      <Aux>
        <Slider className="slider" autoplay={2000}>
          {content.map((item, index) => (
            <StyledLink to={{ pathname: item.linkTo }} key={index}>
              <Title>{item.title}</Title>
              <ImageContainer>
                <BaseImage src={item.image} />
                <TextBlock>
                  <TextLine>{item.textLineOne}</TextLine>
                  <TextLine>{item.textLineTwo}</TextLine>
                  <TextLine>{item.textLineThree}</TextLine>
                </TextBlock>
              </ImageContainer>
            </StyledLink>
          ))}
        </Slider>
      </Aux>
    );
  }
}

export default IndexNew;



// WEBPACK FOOTER //
// ./src/components/Pages/Index/IndexNew.js